import { createReducer, on } from '@ngrx/store';

import { RemoteDiagnosticsUseCasesActions } from './remote-diagnostics-use-cases.actions';
import { RemoteDiagnosticsUseCasesState } from './remote-diagnostics-use-cases.state';

export const initRemoteDiagnosticsUseCasesState: RemoteDiagnosticsUseCasesState = {
  useCases: null,
  useCaseGroups: null,
  vddListLoaded: false,
  vddListLoading: false,
  loading: false,
  loaded: false,
  error: null,
};

export const remoteDiagnosticsUseCasesReducer = createReducer(
  initRemoteDiagnosticsUseCasesState,

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCasesAttempt,
    (state): RemoteDiagnosticsUseCasesState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCasesSuccess,
    (state, { useCases }): RemoteDiagnosticsUseCasesState => ({
      ...state,
      useCases,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCasesFailed,
    (state, { error }): RemoteDiagnosticsUseCasesState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  ),

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCaseVddListAttempt,
    (state): RemoteDiagnosticsUseCasesState => ({
      ...state,
      vddListLoaded: false,
      vddListLoading: true,
    })
  ),

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCaseVddListSuccess,
    (state): RemoteDiagnosticsUseCasesState => ({
      ...state,
      vddListLoaded: true,
      vddListLoading: false,
    })
  ),

  on(
    RemoteDiagnosticsUseCasesActions.loadUseCaseVddListFailed,
    (state, { error }): RemoteDiagnosticsUseCasesState => ({
      ...state,
      vddListLoaded: true,
      vddListLoading: false,
      error,
    })
  )
);
